import { triggerSimpleAjax } from '../../helpers/httpHelper';
import { GET_VIEW_MOBILE } from '../../helpers/constants/apiUrl';

export default function getMobileView(req = '') {
    return new Promise((res, rej) => {
        triggerSimpleAjax(
            GET_VIEW_MOBILE + req +"/" ,
            'GET',
            {},
            (response) => {
                res(response);
            },
            error => {
                rej(error);
            }
        );
    });
}

